<script setup>
import { useAssessment } from '@/composables/useAssessment'
import { useAbility } from '@casl/vue'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Assessment',
  },
})

const router = useRouter()
const ability = useAbility()
const { templates, loading, fetchTemplates } = useAssessment()

onMounted(fetchTemplates)

const headers = [
  { title: 'Nama', key: 'name' },
  { title: 'Kategori', key: 'category' },
  { title: 'Jumlah Kriteria', key: 'criteria' },
  { title: 'Status', key: 'is_active', width: 110 },
  { title: 'Aksi', key: 'actions', align: 'center', sortable: false, width: 120 },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap gap-3">
          <div>
            <h4 class="text-h4 font-weight-bold">
              Template Penilaian
            </h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Penilaian berbasis skor — KPI, Penilaian Pegawai, Evaluasi Vendor (§10.4)
            </p>
          </div>
          <VBtn
            v-if="ability.can('template-manage', 'Assessment')"
            prepend-icon="ri-add-line"
            @click="router.push({ name: 'assessment-templates-create' })"
          >
            Tambah Template
          </VBtn>
        </div>
      </VCol>
    </VRow>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="templates"
        :loading="loading"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #item.category="{ item }">
          {{ item.category?.name ?? '-' }}
        </template>
        <template #item.criteria="{ item }">
          {{ item.criteria_count ?? '-' }}
        </template>
        <template #item.is_active="{ item }">
          <VChip
            size="small"
            :color="item.is_active ? 'success' : 'secondary'"
          >
            {{ item.is_active ? 'Aktif' : 'Nonaktif' }}
          </VChip>
        </template>
        <template #item.actions="{ item }">
          <VBtn
            v-if="ability.can('score', 'Assessment')"
            size="small"
            variant="text"
            color="primary"
            prepend-icon="ri-star-line"
            @click="router.push({ name: 'assessment-score-template-id', params: { templateId: item.id } })"
          >
            Nilai
          </VBtn>
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Belum ada template penilaian.
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
